import { component } from 'picoapp';
import { each } from 'lodash-es';
import { TweenMax } from 'gsap';
import delegate from 'delegate';
const hoverintent = require('hoverintent');

class TopMenuItem {
  constructor(el) {
    this.el = el;
    this.submenu = el.querySelector(':scope > .Nav__submenu');
    this.infoWrapper = el.querySelector('.Nav__info');
    this.infoContent = el.querySelector('.Nav__info .wrapper');
    this.subOptions = el.querySelectorAll('.Nav__item');

    if (this.submenu) {
      // this.setInitialValues();
      this.bindEvents();
    }
  }

  bindEvents() {
    let intentOptions = {
      timeout: 250,
      interval: 100
    };

    hoverintent(this.el, this.open.bind(this), this.close.bind(this)).options(intentOptions);

    // If link contains only an empty hash, prevent jumping on the page
    delegate(
      this.el,
      'a',
      'click',
      (e) => {
        if (e.target.href) {
          let hash = e.target.href.substring(e.target.href.indexOf('#'));
          if (hash === '#') {
            e.preventDefault();
          }
        }
      },
      false
    );

    each(this.subOptions, (el) => {
      el.addEventListener('mouseenter', (ev) => {
        this.swapInfo(ev.target);
      });
    });
  }

  setInitialValues() {
    this.menuSizing = this.submenu.getBoundingClientRect();
  }

  setCoordinates() {
    let coordinates = this.el.getBoundingClientRect();
  }

  open() {
    TweenMax.set(this.submenu, { display: 'flex' });
    TweenMax.from(this.submenu, 0.8, {
      y: '40px',
      opacity: 0,
      ease: Expo.easeOut
    });
    this.setInitialValues();
  }

  close() {
    TweenMax.set(this.submenu, { display: 'none' });
  }

  swapInfo(newOption) {
    let targetInfo = newOption.querySelector('.details-info');
    if (targetInfo) {
      this.expandSubMenu(targetInfo.innerHTML);
    } else {
      this.collapseSubMenu();
    }
  }

  expandSubMenu(newInfo) {
    TweenMax.to(this.infoWrapper, 0.5, {
      left: '100%',
      autoAlpha: 1,
      ease: Expo.easeOut
    });
    TweenMax.to(this.infoContent, 0.6, { opacity: 0 });
    TweenMax.to(this.submenu, 0.4, {
      height: this.menuSizing.height,
      ease: Expo.easeOut
    });
    this.infoContent.innerHTML = newInfo;
    TweenMax.to(this.submenu, 0.4, {
      height: Math.max(this.infoContent.getBoundingClientRect().height, this.menuSizing.height),
      ease: Expo.easeOut
    });
    TweenMax.to(this.infoContent, 0.6, { opacity: 1 });
  }

  collapseSubMenu() {
    TweenMax.to(this.infoWrapper, 0.5, {
      left: '0%',
      autoAlpha: 0,
      ease: Expo.easeOut
    });
  }
}

class MainNav {
  constructor(el, ctx) {
    this.el = el;
    this.menuItems = el.querySelectorAll('.Nav__item--main');
    this.init();
  }

  init() {
    each(this.menuItems, (el) => {
      new TopMenuItem(el);
    });
  }
}

// export default MainNav;
export default component((node, ctx) => {
  new MainNav(node, ctx);
});
